import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.scss']
})
export class CountryComponent {


  public dataListing:any=[];
  public loading:boolean = true;
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public CurrentUrl:any=this.router.url;
  public Ids:any='';
  public reasons:any='';
  public statuskey:any='';
  public id:any='';

  constructor(public router: Router, public service: GlobalService) { 
    if(this.CurrentUrl=='/country'){
      localStorage.removeItem('hva_cid');
    }
    this.getDetail(this.p);
   }

   getDetail(page:any){
    this.loading=true;
    var url="";
    if(this.CurrentUrl =='/country'){
      url="master/countries";
    } else {
      url="master/cities/"+localStorage.getItem('hva_cid');
    }
    if(this.searchKey!=''){
      url=url+'&search='+this.searchKey;
    }
    if(this.statuskey!=''){
      url=url+'&status='+this.statuskey;
    }
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self =this; 
        this.dataListing=response.data ;
        this.totalCount = response.totalCounts;  
        this.loading=false;
      } else {
        this.dataListing=[];
        this.totalCount =  response.totalCounts;  
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  redirect(item:any){
    localStorage.setItem('hva_cid',item);
    this.router.navigate(['/city']);
  }
}
